import { FETCH_REPORT_CASES, FETCH_REPORT_CASES_LOADING } from '../actions/types'

const INITIAL_STATE = {
    items: null,
    loading: false
}

function reportCasesReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_REPORT_CASES_LOADING:
            return { ...state, loading: action.payload }
        case FETCH_REPORT_CASES:
            return { ...state, items: action.payload }
        default:
            return state
    }
}

export default reportCasesReducer